import { cssGenerator, hdrm, view } from '@yola/ws-sdk';

const { UPDATE_LIVE_ONLY } = hdrm.constants.updateStrategies;

const regenerateAtomicCSS = async (config, payload) => {
  const { elementId, attr, options = {} } = payload;
  if (attr) {
    const { supportedAttributes } = cssGenerator.constants;

    if (!elementId || (attr !== 'class' && !supportedAttributes.includes(attr))) {
      return [];
    }
  }

  const dom =
    options.strategy === UPDATE_LIVE_ONLY
      ? view.accessors.getLiveDocument()
      : hdrm.instance.driver.getStaticDocument();
  const css = await cssGenerator.operations.generateCssFromHtml(dom.body.innerHTML);

  return [
    {
      instructions: [
        {
          regenerateCSS: true,
          css,
        },
      ],
    },
  ];
};

export default regenerateAtomicCSS;
